var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1887",
    "data-name": "Group 1887",
    transform: "translate(-690 -316)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_670",
    "data-name": "Ellipse 670",
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    transform: "translate(690 316)",
    fill: "#2cff00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "done_black_24dp_1_",
    "data-name": "done_black_24dp (1)",
    transform: "translate(696.781 322.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8281",
    "data-name": "Path 8281",
    d: "M0,0H31.746V31.746H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8282",
    "data-name": "Path 8282",
    d: "M10.807,19.621,5.252,14.066,3.4,15.917l7.407,7.407L26.68,7.452,24.829,5.6Z",
    transform: "translate(1.097 1.807)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/Confirm.69d55cd0310b73bbf6900714d4de629c.svg";
export { ForwardRef as ReactComponent };